import { setUpClickHandlers } from '../utils/clickHandlers';

/**
 * Fetches a list of identifiable breeds, groups related items alphabetically,
 * wraps them in HTML and draws them to the page.
 *
 * @since 2018-08-13
 * @uses groupByFirstLetter
 * @see sections/product-template.liquid
 */
export async function drawBreedList() {
  // Container to place generated HTML inside.
  const $mountNode = $('#breed-list');
  if (!$mountNode.length) {
    return; // Exit early if there is nowhere to draw the list.
  }

  setUpClickHandlers($mountNode);
}
